import script from "./RedPacket.vue?vue&type=script&setup=true&lang=ts"
export * from "./RedPacket.vue?vue&type=script&setup=true&lang=ts"

import "./RedPacket.vue?vue&type=style&index=0&id=1e59b352&lang=scss"

const __exports__ = script;

export default __exports__